export const menu = {
    label: 'Participantes',
    icon: 'pi pi-fw pi-book',
    to: '/brasilmais/participantes',
    rules: ['BRASILMAIS-00'],
};
